import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BoxSeparator,
  ForbiddenSection,
  Page,
  TitleBox,
  Button,
  ContentBox,
} from "../../../../../components";
import { toast } from "react-toastify";
import ROUTES from "../../../../../routes";
import { Language } from "../../../../../utils";
import { business as businessActions } from "../../../../../actions";
import { goBack } from "connected-react-router";
import makeClasses from "./styles";
import { Policies } from "../../../../../utils/Policies";
import { Publish as UploadIcon } from "@material-ui/icons";

const ProvidersSubscriptionsEditTermsAndConditionscreen = ({ match }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();
  const uploadInputRef = useRef(null);
  const { policies, languageTexts } = useSelector((state) => ({
    policies: state.user.userData.policies || [],
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);
  const subscriptionPlanTraceId =
    match && match.params ? match.params.traceId : null;
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [forbiddenSection, setForbbidenSection] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      policies &&
      policies.includes(Policies.types.PROVIDERS_SUBSCRIPTIONS_PLANS_WRITE)
    ) {
      dispatch(
        businessActions.getPlanTermsAndConditions(
          subscriptionPlanTraceId,
          (data) => {
            console.log(data);
          }
        )
      );
    } else {
      setForbbidenSection(true);
    }
  }, []);

  const handleOnGoBackClick = () => {
    dispatch(goBack());
  };

  const _goBack = (e) => {
    e.preventDefault();
    dispatch(goBack());
  };

  const handleOnFileUpload = (e) => {
    const files = e.currentTarget.files;
    const fileName = files[0]?.name;
    setFileName(fileName);
    setFile(files[0]);
  };

  const _submitForm = () => {
    dispatch(
      businessActions.uploadPlanTermsAndConditions(
        subscriptionPlanTraceId,
        file,
        (result) => {
          if (result) {
            toast.success(
              i18n.get("ProvidersSubscriptionsAddPlan.SuccessAddMessage")
            );
            setTimeout(() => {
              dispatch(goBack());
            }, 500);
          } else {
            toast.error("Error al subir el archivo");
          }
        }
      )
    );
  };

  if (forbiddenSection) {
    return (
      <Page
        withHeader
        withSidebar
        withHeaderTitle={i18n.get(
          "ProvidersSubscriptionsEditTermsAndConditions.Title"
        )}
        withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}>
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page
      withHeader
      withSidebar
      withHeaderTitle={i18n.get(
        "ProvidersSubscriptionsEditTermsAndConditions.Title"
      )}
      withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}>
      <TitleBox
        title={i18n.get("ProvidersSubscriptionsEditTermsAndConditions.Title")}
        back
        backTitle={i18n.get(
          "ProvidersSubscriptionsEditTermsAndConditions.BackButton"
        )}
        onBackClick={handleOnGoBackClick}
        backButtonVariant="outlined"
      />
      <BoxSeparator />
      <React.Fragment>
        <ContentBox
          title={i18n.get(
            "ProvidersSubscriptionsEditTermsAndConditions.BoxTitle"
          )}>
          <div className={classes.inputFile}>
            <input
              ref={uploadInputRef}
              id="file"
              type="file"
              accept="application/pdf"
              onChange={handleOnFileUpload}
            />
            <label htmlFor="file">
              <div>{i18n.get("Components.NoTCModal.FileInputLabel")}</div>
              {fileName && fileName.length > 0
                ? fileName
                : i18n.get("Components.NoTCModal.FileInputPlaceholder")}
              <div className={classes.inputFileIcon}>
                <UploadIcon fontSize="small" />
              </div>
            </label>
          </div>
          <div className={classes.contentActionsWrapper}>
            <Button variant="outlined" onClick={_goBack}>
              {i18n.get("ProvidersSubscriptionsAddPlan.CancelButton")}
            </Button>
            <Button disabled={!file} onClick={_submitForm}>
              {i18n.get("ProvidersSubscriptionsAddPlan.SaveButton")}
            </Button>
          </div>
        </ContentBox>
        <BoxSeparator size="small" />
      </React.Fragment>
    </Page>
  );
};

ProvidersSubscriptionsEditTermsAndConditionscreen.id =
  "com.Handy.ProvidersSubscriptionsEditTermsAndConditions";

export default ProvidersSubscriptionsEditTermsAndConditionscreen;
